import { DirectiveBase } from '../angular-directive-base.directive';

export class ActStep extends DirectiveBase {
    constructor() {
        super();
        this.restrict = 'E';
        this.require = ['^^actStepper'];
        this.transclude = true;
        this.scope = {
            desc: '=',
            counter: '='
        };
        this.templateUrl = 'app/angularJS/components/stepper/act-step.html';
        this.link = (scope: any, element, attrs, actStepper: Array<any>) => {
            this.linkFunction(scope, element, attrs, actStepper);
        };
    }

    public linkFunction(scope: any, element, attrs, actStepper: Array<any>) {
        const actStepperCtrl = actStepper[0];
        actStepperCtrl.addStep(scope);
    }
}
